import Layout from "components/Layout";
import { Head } from "../../components/Head";
import React from "react";

const Terms = () => {
  return (
    <Layout>
      <Head title={"Terms and Conditions - DiJT NFT Platform"} />
      <div className="pt-[5.5rem] lg:pt-24">
        {/* <!-- TOS --> */}
        <section className="dark:bg-jacarta-800 relative py-16 md:py-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
            <img
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full w-full"
            />
          </picture>
          <div className="container">
            <h1 className="font-display text-jacarta-700 text-center text-4xl font-medium dark:text-white">
              Terms and Conditions for DiJT NFT Platform
            </h1>
            <div className="article-content mx-auto max-w-[48.125rem]">
              <div className="bg-white dark:bg-jacarta-800 shadow-md rounded px-8 pt-6 pb-8 mb-4 flex flex-col">
                <div className="mb-4">
                  <h2 className="font-bold mb-2">1. Introduction</h2> 
                  <p>
                    DiJT is an NFT (Non-Fungible Token) platform that provides a
                    marketplace for buying, selling, and showcasing NFTs. Our
                    platform is designed to allow users to view and interact
                    with NFTs using blockchain technology.
                  </p>
                </div> 
                <div className="mb-4">
                  <h2 className="font-bold mb-2">2. User Responsibility</h2>
                  <p>
                    By using DiJT, you are responsible for your own actions and
                    decisions. You are also responsible for ensuring that any
                    NFTs you purchase through our platform are genuine and not
                    fraudulent.
                  </p>
                </div>
                <div className="mb-4">
                  <h2 className="font-bold mb-2">
                    3. No Liability for Scams or Fraudulent NFTs
                  </h2>
                  <p>
                    DiJT is not responsible for any scams or fraudulent NFTs
                    that may be present on our platform. We are simply a
                    showcase for NFT data and do not have any control over the
                    authenticity of NFTs. It is up to the users to exercise
                    caution and due diligence when purchasing NFTs.
                  </p>
                </div>
                <div className="mb-4">
                  <h2 className="font-bold mb-2">4. No Refund Policy</h2>
                  <p>
                    DiJT does not offer refunds for any NFT purchases made on
                    our platform. All transactions are final, and it is up to
                    the user to ensure that they are satisfied with the NFT they
                    are purchasing before making a transaction.
                  </p>
                </div>
                <div className="mb-4">
                  <h2 className="font-bold mb-2">5. User Generated Content</h2>
                  <p>
                    DiJT allows users to upload and showcase their NFTs on our
                    platform. By uploading NFTs to our platform, you are
                    granting DiJT a non-exclusive, royalty-free, worldwide
                    license to display and promote your NFTs. You are also
                    responsible for ensuring that any content you upload does
                    not infringe on any third-party rights.
                  </p>
                </div>
                <div className="mb-4">
                  <h2 className="font-bold mb-2">
                    6. Intellectual Property Rights
                  </h2>
                  <p>
                    All NFTs, logos, and trademarks on our platform are the
                    property of their respective owners. Any unauthorized use of
                    these assets is strictly prohibited and may be subject to
                    legal action.
                  </p>
                </div>
                <div className="mb-4">
                  <h2 className="font-bold mb-2">
                    7. Changes to Terms and Conditions
                  </h2>
                  <p>
                    DiJT reserves the right to change these terms and conditions
                    at any time. It is the responsibility of the user to
                    periodically review these terms and conditions to ensure
                    they are aware of any changes.
                  </p>
                </div>
                <div className="mb-4">
                  <h2 className="font-bold mb-2">8. Governing Law</h2>
                  <p>
                    These terms and conditions shall be governed and construed
                    in accordance with the laws of the jurisdiction in which
                    DiJT operates.
                  </p>
                </div>
                <div className="mb-4">
                  <h2 className="font-bold mb-2">9. Contact Us</h2>
                  <p>
                    If you have any questions or concerns about these terms and
                    conditions, please contact us at support@dijt.io.
                  </p>
                </div>
                <div className="mb-4">
                  <p>By using DiJT, you agree to these terms and conditions.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- end TOS --> */}
      </div>
    </Layout>
  );
};

export default Terms;